import { makeStyles } from '@mui/styles';

const ViewMessageSyncUpStyles = makeStyles(() => ({
	root: {
		backgroundColor: 'rgba(255, 255, 255, 0.2)',
		alignItems: 'center',
		display: 'flex',
		height: '100vh',
		justifyContent: 'center',
		left: 0,
		position: 'fixed',
		top: 0,
		width: '100%',
		zIndex: 1301,
	},
	rootC: {
		backdropFilter: 'blur(3px)',
		background: 'rgba(0, 0, 0, 0.5)',
		height: '100%',
		left: 0,
		position: 'absolute',
		top: 0,
		width: '100%',
		zIndex: 1,
	},
	card: {
		backgroundColor: '#FFFFFF',
		zIndex: 1300,
		borderRadius: 10,
		width: 323,
		height: 187,
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		maxHeight: '91%',
		overflow: 'hidden',
	},
	button: {
		width: 103,
		height: 32,
		boxShadow: '0px 3px 3px #00000029 !important',
		borderRadius: '4px !important',
		fontSize: '12px !important',
		fontWeight: '600 !important',
		fontFamily: 'Montserrat !important',
		marginTop: '5px !important',
	},
	tittle: {
		fontfamily: 'Montserrat',
		fontWeight: '700 !important',
		fontSize: '16px',
		color: '#003C82',
		marginTop: '15px !important',
		letterSpacing: 0,
		textAlign: 'left',
		marginLeft: '25px !important',
		marginBottom: '10px !important',
	},
	tittleTable: {
		textAlign: 'left',
		fontSize: '12px',
		color: '#707070',
		fontfamily: 'Montserrat !important',
		fontWeight: '500 !important',
		padding: '0px 15px 0px 15px',
	},
	texto: {
		color: '#000000 !important',
		textAlign: 'left',
		letterSpacing: 0,
		padding: '0px 15px 0px 15px',
	},
}));

export default ViewMessageSyncUpStyles;
